import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';

@Component({
  selector: 'app-leprosy-modal',
  templateUrl: './leprosy-modal.component.html',
  styleUrls: ['./leprosy-modal.component.css'],
})
export class LeprosyModalComponent implements OnInit {
  @Input() benID: any
  @Input() AlraedyDataAdded: any
  leprosyForm: FormGroup;


  constructor(
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formInIt();
  }

  formInIt() {
    this.leprosyForm = this.fb.group({
      skin_patch_present: [],
      loss_of_sensation: [],
      numbness_in_hands_feet: [],
      visible_deformity: [],
      screening_result: [],
      referred: [],
      referral_facility:[]
    });
  }

  onSave() {
    console.log("this.leprosyForm.value", this.leprosyForm.value);
    this.activeModal.close(this.leprosyForm.value);
  }




}
